import { SERVICES_CONTENT } from "../pages/services/servicesContent";

const productArticles = [
  {
    idRefArticle: "prod-printers",
    type: 1,
    title: "Imprimante d'\u00e9tiquettes",
    titre: "Imprimante d'\u00e9tiquettes",
    shortTitre: "Imprimante d'\u00e9tiquettes",
    description:
      "Large s\u00e9lection d'imprimantes performantes certifi\u00e9es par des marques de renomm\u00e9e mondiale. Fiables, durables et rapides, nos imprimantes d'\u00e9tiquettes sont con\u00e7ues pour s'adapter aux divers environnements, besoins et volumes d'impression.",
    shortDescription:
      "Large s\u00e9lection d'imprimantes performantes certifi\u00e9es par des marques de renomm\u00e9e mondiale.",
    url: "/produits/imprimantes",
    image: "/images/Produits/1.webp",
    shortImage: "/images/Produits/1.webp",
    slug: "/produits/imprimantes",
    rtl: true,
  },
  {
    idRefArticle: "prod-scanners",
    type: 1,
    title: "Scanners de code \u00e0 barres",
    titre: "Scanners de code \u00e0 barres",
    shortTitre: "Scanners de code \u00e0 barres",
    description:
      "Solutions d'identification automatique et lecture de codes \u00e0 barres pour vous aider \u00e0 optimiser et garantir la tra\u00e7abilit\u00e9 de l'ensemble de vos op\u00e9rations. Douchettes et scanners intelligents avec des performances exceptionnelles adapt\u00e9es \u00e0 toute application.",
    shortDescription:
      "Solutions d'identification automatique et lecture de codes \u00e0 barres pour garantir la tra\u00e7abilit\u00e9.",
    url: "/produits/scanners",
    image: "/images/Produits/2.webp",
    shortImage: "/images/Produits/2.webp",
    slug: "/produits/scanners",
    rtl: false,
  },
  {
    idRefArticle: "prod-vehicle",
    type: 1,
    title: "Terminaux embarqu\u00e9s",
    titre: "Terminaux embarqu\u00e9s",
    shortTitre: "Terminaux embarqu\u00e9s",
    description:
      "Revitalisez vos engins d'entrep\u00f4ts en y int\u00e9grant des terminaux embarqu\u00e9s robustes et r\u00e9sistants dot\u00e9s des derni\u00e8res versions des syst\u00e8mes d'exploitation. Disponibles en plusieurs tailles d'\u00e9cran, nos appareils embarqu\u00e9s sont optimis\u00e9s pour augmenter la productivit\u00e9 de vos op\u00e9rateurs en milieu industriel et entrep\u00f4t.",
    shortDescription:
      "Terminaux embarqu\u00e9s robustes pour augmenter la productivit\u00e9 en milieu industriel et entrep\u00f4t.",
    url: "/produits/terminaux-embarques",
    image: "/images/Produits/3.webp",
    shortImage: "/images/Produits/3.webp",
    slug: "/produits/terminaux-embarques",
    rtl: true,
  },
  {
    idRefArticle: "prod-mobile",
    type: 1,
    title: "Terminaux mobiles",
    titre: "Terminaux mobiles",
    shortTitre: "Terminaux mobiles",
    description:
      "Nous proposons un choix \u00e9tendu de terminaux professionnels durcis pour booster la productivit\u00e9 de vos \u00e9quipes. Dot\u00e9s des fonctionnalit\u00e9s avanc\u00e9es de collecte, d'identification et partage de donn\u00e9es sans fil et en temps r\u00e9el, nos PDA et smartphones offrent \u00e0 vos op\u00e9rateurs une pleine satisfaction m\u00eame dans les conditions les plus extr\u00eames.",
    shortDescription:
      "Terminaux professionnels durcis pour booster la productivit\u00e9 de vos \u00e9quipes terrain.",
    url: "/produits/terminaux-mobiles",
    image: "/images/Produits/4.webp",
    shortImage: "/images/Produits/4.webp",
    slug: "/produits/terminaux-mobiles",
    rtl: false,
  },
  {
    idRefArticle: "prod-software",
    type: 1,
    title: "Logiciels",
    titre: "Logiciels",
    shortTitre: "Logiciels",
    description:
      "Afin d'atteindre l'excellence op\u00e9rationnelle, compl\u00e9tez vos processus logistiques avec nos solutions logicielles. Simples et intuitives, nos offres logicielles sur cloud ont \u00e9t\u00e9 sp\u00e9cialement pens\u00e9es pour int\u00e9grer vos l'ensemble de vos \u00e9quipements en toute s\u00e9curit\u00e9.",
    shortDescription:
      "Solutions logicielles simples et intuitives pour compl\u00e9ter vos processus logistiques.",
    url: "/produits/logiciels",
    image: "/images/Produits/5.webp",
    shortImage: "/images/Produits/5.webp",
    slug: "/produits/logiciels",
    rtl: true,
  },
  {
    idRefArticle: "prod-tablets",
    type: 1,
    title: "Tablettes industrielles",
    titre: "Tablettes industrielles",
    shortTitre: "Tablettes industrielles",
    description:
      "Avec notre s\u00e9lection de tablettes industrielles, vous pouvez acc\u00e9l\u00e9rer votre vitesse d'ex\u00e9cution en entrep\u00f4t ou sites de production. Adapt\u00e9es aux applications industrielles les plus exigeantes notre offre comprend des tablettes robustes, \u00e9tanches et r\u00e9sistantes aux impacts, \u00e0 la poussi\u00e8re et aux temp\u00e9ratures extr\u00eames.",
    shortDescription:
      "Tablettes industrielles robustes pour acc\u00e9l\u00e9rer l'ex\u00e9cution en entrep\u00f4t ou production.",
    url: "/produits/tablettes-industrielles",
    image: "/images/Produits/6.webp",
    shortImage: "/images/Produits/6.webp",
    slug: "/produits/tablettes-industrielles",
    rtl: false,
  },
  {
    idRefArticle: "prod-wifi",
    type: 1,
    title: "Infrastructure Wi-Fi",
    titre: "Infrastructure Wi-Fi",
    shortTitre: "Infrastructure Wi-Fi",
    description:
      "Lib\u00e9rez-vous des contraintes du r\u00e9seau en choisissant des points d'acc\u00e8s Wi-Fi et des syst\u00e8mes de gestion de nouvelle g\u00e9n\u00e9ration. Teledyne vous offre une s\u00e9lection des produits logiciels et mat\u00e9riels qui vous garantissent une infrastructure flexible et 100 % s\u00e9curis\u00e9e.",
    shortDescription:
      "Points d'acc\u00e8s Wi-Fi et syst\u00e8mes de gestion pour une infrastructure flexible et s\u00e9curis\u00e9e.",
    url: "/produits/infrastructure-wi-fi",
    image: "/images/Produits/7.webp",
    shortImage: "/images/Produits/7.webp",
    slug: "/produits/infrastructure-wi-fi",
    rtl: true,
  },
  {
    idRefArticle: "prod-consumables",
    type: 1,
    title: "Consommables pour impression",
    titre: "Consommables pour impression",
    shortTitre: "Consommables",
    description:
      "Nous vous accompagnons pour vos projets d'\u00e9tiquetage gr\u00e2ce \u00e0 notre offre large de consommables d'impression. Des consommables code-barre et RFID de haute qualit\u00e9 sont disponibles en papier et en mat\u00e9riaux synth\u00e9tiques pour vos impressions thermiques directes ou \u00e0 transfert.",
    shortDescription:
      "Consommables code-barre et RFID pour impressions thermiques directes ou \u00e0 transfert.",
    url: "/produits/consommables",
    image: "/images/Produits/8.webp",
    shortImage: "/images/Produits/8.webp",
    slug: "/produits/consommables",
    rtl: false,
  },
  {
    idRefArticle: "prod-kiosks",
    type: 1,
    title: "Bornes interactives & kiosques",
    titre: "Bornes interactives & kiosques",
    shortTitre: "Bornes & kiosques",
    description:
      "Bornes interactives et kiosques libre-service pour l'accueil, l'orientation, la prise de commande et les services autonomes. Solutions adapt\u00e9es au retail, restauration, services publics et espaces \u00e0 forte fr\u00e9quentation.",
    shortDescription:
      "Bornes interactives et kiosques libre-service pour accueil, orientation et services autonomes.",
    url: "/produits/bornes-interactives-kiosques",
    image: "/images/Produits/9.webp",
    shortImage: "/images/Produits/9.webp",
    slug: "/produits/bornes-interactives-kiosques",
    rtl: true,
  },
  {
    idRefArticle: "prod-pos",
    type: 1,
    title: "Terminaux point de vente",
    titre: "Terminaux point de vente",
    shortTitre: "Terminaux point de vente",
    description:
      "Solutions compl\u00e8tes d'encaissement pour magasins, superettes et r\u00e9seaux de distribution. Terminaux POS tactiles, p\u00e9riph\u00e9riques int\u00e9gr\u00e9s, affichage cuisine et gestion des flux pour un encaissement rapide, fiable et s\u00e9curis\u00e9.",
    shortDescription:
      "Solutions compl\u00e8tes d'encaissement POS pour magasins, superettes et r\u00e9seaux de distribution.",
    url: "/produits/terminaux-point-de-vente",
    image: "/images/Produits/pos-caisse.webp",
    shortImage: "/images/Produits/pos-caisse.webp",
    slug: "/produits/terminaux-point-de-vente",
    rtl: false,
  },
];

const homeProductArticles = [
  {
    idRefArticle: "home-prod-printers",
    type: 1,
    title: "Imprimantes d'\u00e9tiquettes",
    titre: "Imprimantes d'\u00e9tiquettes",
    shortTitre: "Imprimantes d'\u00e9tiquettes",
    description:
      "Large s\u00e9lection d'imprimantes performantes certifi\u00e9es par des marques de renomm\u00e9e mondiale. Fiables, durables et rapides, nos imprimantes d'\u00e9tiquettes sont con\u00e7ues pour s'adapter aux divers environnements, besoins et volumes d'impression.",
    shortDescription:
      "Large s\u00e9lection d'imprimantes performantes certifi\u00e9es par des marques de renomm\u00e9e mondiale.",
    url: "/produits/imprimantes",
    image: "/images/Produits/4-imprimante-mobile-etiquette.webp",
    shortImage: "/images/Produits/4-imprimante-mobile-etiquette.webp",
    slug: "/produits/imprimantes",
    rtl: true,
  },
  {
    idRefArticle: "home-prod-scanners",
    type: 1,
    title: "Lecteurs de code \u00e0 barre",
    titre: "Lecteurs de code \u00e0 barre",
    shortTitre: "Lecteurs de code \u00e0 barre",
    description:
      "Solutions d'identification automatique et lecture de codes \u00e0 barres pour vous aider \u00e0 optimiser et garantir la tra\u00e7abilit\u00e9 de l'ensemble de vos op\u00e9rations. Douchettes et scanners intelligents avec des performances exceptionnelles adapt\u00e9es \u00e0 toute application.",
    shortDescription:
      "Solutions d'identification automatique et lecture de codes \u00e0 barres pour garantir la tra\u00e7abilit\u00e9.",
    url: "/produits/scanners",
    image: "/images/Produits/lecteur-codebarres-durci.webp",
    shortImage: "/images/Produits/lecteur-codebarres-durci.webp",
    slug: "/produits/scanners",
    rtl: false,
  },
  {
    idRefArticle: "home-prod-vehicle",
    type: 1,
    title: "Terminaux embarqu\u00e9s",
    titre: "Terminaux embarqu\u00e9s",
    shortTitre: "Terminaux embarqu\u00e9s",
    description:
      "Revitalisez vos engins d'entrep\u00f4ts en y int\u00e9grant des terminaux embarqu\u00e9s robustes et r\u00e9sistants dot\u00e9s des derni\u00e8res versions des syst\u00e8mes d'exploitation. Disponibles en plusieurs tailles d'\u00e9cran, nos appareils embarqu\u00e9s sont optimis\u00e9s pour augmenter la productivit\u00e9 de vos op\u00e9rateurs en milieu industriel et entrep\u00f4t.",
    shortDescription:
      "Terminaux embarqu\u00e9s robustes pour augmenter la productivit\u00e9 en milieu industriel et entrep\u00f4t.",
    url: "/produits/terminaux-embarques",
    image:
      "/images/Produits/vc8300-photography-application-warehouse-trailer-truck-app-putaway-web-72dpi.webp",
    shortImage:
      "/images/Produits/vc8300-photography-application-warehouse-trailer-truck-app-putaway-web-72dpi.webp",
    slug: "/produits/terminaux-embarques",
    rtl: true,
  },
  {
    idRefArticle: "home-prod-mobile",
    type: 1,
    title: "Terminaux portables",
    titre: "Terminaux portables",
    shortTitre: "Terminaux portables",
    description:
      "Nous proposons un choix \u00e9tendu de terminaux professionnels durcis pour booster la productivit\u00e9 de vos \u00e9quipes. Dot\u00e9s des fonctionnalit\u00e9s avanc\u00e9es de collecte, d'identification et partage de donn\u00e9es sans fil et en temps r\u00e9el, nos PDA et smartphones offrent \u00e0 vos op\u00e9rateurs une pleine satisfaction m\u00eame dans les conditions les plus extr\u00eames.",
    shortDescription:
      "Terminaux professionnels durcis pour booster la productivit\u00e9 de vos \u00e9quipes terrain.",
    url: "/produits/terminaux-mobiles",
    image: "/images/Produits/8187651b-1f83-4dd7-a8b4-e92326db9ab2.webp",
    shortImage: "/images/Produits/8187651b-1f83-4dd7-a8b4-e92326db9ab2.webp",
    slug: "/produits/terminaux-mobiles",
    rtl: false,
  },
  {
    idRefArticle: "home-prod-software",
    type: 1,
    title: "Logiciels",
    titre: "Logiciels",
    shortTitre: "Logiciels",
    description:
      "Afin d'atteindre l'excellence op\u00e9rationnelle, compl\u00e9tez vos processus logistiques avec nos solutions logicielles. Simples et intuitives, nos offres logicielles sur cloud ont \u00e9t\u00e9 sp\u00e9cialement pens\u00e9es pour int\u00e9grer vos l'ensemble de vos \u00e9quipements en toute s\u00e9curit\u00e9.",
    shortDescription:
      "Solutions logicielles simples et intuitives pour compl\u00e9ter vos processus logistiques.",
    url: "/produits/logiciels",
    image: "/images/Produits/logiciel-systeme-integre.webp",
    shortImage: "/images/Produits/logiciel-systeme-integre.webp",
    slug: "/produits/logiciels",
    rtl: true,
  },
  {
    idRefArticle: "home-prod-tablets",
    type: 1,
    title: "Tablettes",
    titre: "Tablettes",
    shortTitre: "Tablettes",
    description:
      "Avec notre s\u00e9lection de tablettes industrielles, vous pouvez acc\u00e9l\u00e9rer votre vitesse d'ex\u00e9cution en entrep\u00f4t ou sites de production. Adapt\u00e9es aux applications industrielles les plus exigeantes notre offre comprend des tablettes robustes, \u00e9tanches et r\u00e9sistantes aux impacts, \u00e0 la poussi\u00e8re et aux temp\u00e9ratures extr\u00eames.",
    shortDescription:
      "Tablettes industrielles robustes pour acc\u00e9l\u00e9rer l'ex\u00e9cution en entrep\u00f4t ou production.",
    url: "/produits/tablettes-industrielles",
    image: "/images/Produits/tablette-industrielle-zebra.webp",
    shortImage: "/images/Produits/tablette-industrielle-zebra.webp",
    slug: "/produits/tablettes-industrielles",
    rtl: false,
  },
];

const solutionArticles = [
  {
    idRefArticle: "solution-distribution",
    type: 0,
    title: "Distribution et points de vente",
    titre: "Distribution et points de vente",
    category: "Secteur",
    description:
      "Des solutions pour fluidifier les encaissements, la gestion des stocks, l'etiquetage et l'experience client en magasin.",
    image: "/images/NosSolutions/1.webp",
    url: "/solutions/distribution",
    slug: "/solutions/distribution",
  },
  {
    idRefArticle: "solution-logistique",
    type: 0,
    title: "Entrep\u00f4t et supply chain",
    titre: "Entrep\u00f4t et supply chain",
    category: "Secteur",
    description:
      "Des outils de mobilite, scan, impression et tra\u00e7abilite pour accelerer la reception, la preparation et l'expedition.",
    image: "/images/NosSolutions/2.webp",
    url: "/solutions/logistique",
    slug: "/solutions/logistique",
  },
  {
    idRefArticle: "solution-industrie",
    type: 0,
    title: "Industrie",
    titre: "Industrie",
    category: "Secteur",
    description:
      "Des equipements robustes pour suivre la production, identifier les flux et securiser les operations sur site industriel.",
    image: "/images/NosSolutions/3.webp",
    url: "/solutions/industrie",
    slug: "/solutions/industrie",
  },
  {
    idRefArticle: "solution-sante",
    type: 0,
    title: "Sant\u00e9 et pharma",
    titre: "Sant\u00e9 et pharma",
    category: "Secteur",
    description:
      "Des solutions d'identification, d'etiquetage et de mobilite concues pour les exigences sanitaires et pharmaceutiques.",
    image: "/images/NosSolutions/4.webp",
    url: "/solutions/sante",
    slug: "/solutions/sante",
  },
  {
    idRefArticle: "solution-banque",
    type: 0,
    title: "Banques et assurances",
    titre: "Banques et assurances",
    category: "Secteur",
    description:
      "Des dispositifs digitaux pour optimiser l'accueil, la securite, le traitement documentaire et les processus d'agence.",
    image: "/images/NosSolutions/banque-services-terciaire-assurance.webp",
    url: "/solutions/banque",
    slug: "/solutions/banque",
  },
  {
    idRefArticle: "solution-public",
    type: 0,
    title: "Services publics",
    titre: "Services publics",
    category: "Secteur",
    description:
      "Des solutions mobiles et connectees pour moderniser les services terrain, le controle et les operations administratives.",
    image: "/images/NosSolutions/services-publics.webp",
    url: "/solutions/services-publics",
    slug: "/solutions/services-publics",
  },
];

const serviceArticles = Object.entries(SERVICES_CONTENT).map(([slug, service], index) => ({
  idRefArticle: `service-${slug || index}`,
  type: 4,
  titre: service.title || service.heroTitle,
  description: service.heroText || service.subtitle || "",
  image: service.heroImage || "/images/under.webp",
  slug: `/services/${slug}`,
}));

const societeItems = [
  { id: "partner-zebra", type: 1, name: "Zebra", titre: "Zebra", image: "/images/Partenaires/1.webp", logo: "/images/Partenaires/1.webp" },
  { id: "partner-honeywell", type: 1, name: "Honeywell", titre: "Honeywell", image: "/images/Partenaires/2.webp", logo: "/images/Partenaires/2.webp" },
  { id: "partner-bluebird", type: 1, name: "Bluebird", titre: "Bluebird", image: "/images/Partenaires/5.webp", logo: "/images/Partenaires/5.webp" },
  { id: "partner-dascom", type: 1, name: "Dascom", titre: "Dascom", image: "/images/Partenaires/12.webp", logo: "/images/Partenaires/12.webp" },
  { id: "partner-extreme", type: 1, name: "Extreme", titre: "Extreme", image: "/images/Partenaires/11.webp", logo: "/images/Partenaires/11.webp" },
  { id: "partner-cisco", type: 1, name: "Cisco", titre: "Cisco", image: "/images/Partenaires/4.webp", logo: "/images/Partenaires/4.webp" },
  { id: "partner-teklynx", type: 1, name: "Teklynx", titre: "Teklynx", image: "/images/Partenaires/10.webp", logo: "/images/Partenaires/10.webp" },
  { id: "partner-agoralogistics", type: 1, name: "AgoraLogistics", titre: "AgoraLogistics", image: "/images/Partenaires/13.webp", logo: "/images/Partenaires/13.webp" },
  { id: "partner-soti", type: 1, name: "Soti", titre: "Soti", image: "/images/Partenaires/soti-logo.webp", logo: "/images/Partenaires/soti-logo.webp" },
  { id: "client-afric-phar", type: 0, name: "Afric-Phar", titre: "Afric-Phar", image: "/images/Confiance/16.webp", logo: "/images/Confiance/16.webp" },
  { id: "client-aksal", type: 0, name: "Aksal", titre: "Aksal", image: "/images/Confiance/17.webp", logo: "/images/Confiance/17.webp" },
  { id: "client-amendis", type: 0, name: "Amendis", titre: "Amendis", image: "/images/Confiance/18.webp", logo: "/images/Confiance/18.webp" },
  { id: "client-apm-terminal", type: 0, name: "Apm Terminal", titre: "Apm Terminal", image: "/images/Confiance/19.webp", logo: "/images/Confiance/19.webp" },
  { id: "client-credit-du-maroc", type: 0, name: "Cr\u00e9dit du Maroc", titre: "Cr\u00e9dit du Maroc", image: "/images/Confiance/20.webp", logo: "/images/Confiance/20.webp" },
  { id: "client-bottu", type: 0, name: "Bottu", titre: "Bottu", image: "/images/Confiance/21.webp", logo: "/images/Confiance/21.webp" },
  { id: "client-ctm", type: 0, name: "CTM", titre: "CTM", image: "/images/Confiance/22.webp", logo: "/images/Confiance/22.webp" },
  { id: "client-dhl", type: 0, name: "DHL", titre: "DHL", image: "/images/Confiance/23.webp", logo: "/images/Confiance/23.webp" },
  { id: "client-dislog", type: 0, name: "Dislog", titre: "Dislog", image: "/images/Confiance/24.webp", logo: "/images/Confiance/24.webp" },
  { id: "client-fruit-of-the-loom", type: 0, name: "Fruit of the Loom", titre: "Fruit of the Loom", image: "/images/Confiance/25.webp", logo: "/images/Confiance/25.webp" },
  { id: "client-la-voie-express", type: 0, name: "La Voie Express", titre: "La Voie Express", image: "/images/Confiance/26.webp", logo: "/images/Confiance/26.webp" },
  { id: "client-label-vie", type: 0, name: "Label Vie", titre: "Label Vie", image: "/images/Confiance/27.webp", logo: "/images/Confiance/27.webp" },
  { id: "client-lc-waikiki", type: 0, name: "LC Waikiki", titre: "LC Waikiki", image: "/images/Confiance/28.webp", logo: "/images/Confiance/28.webp" },
  { id: "client-cosumar", type: 0, name: "Cosumar", titre: "Cosumar", image: "/images/Confiance/29.webp", logo: "/images/Confiance/29.webp" },
  { id: "client-sothema", type: 0, name: "Sothema", titre: "Sothema", image: "/images/Confiance/30.webp", logo: "/images/Confiance/30.webp" },
  { id: "client-marjane", type: 0, name: "Marjane", titre: "Marjane", image: "/images/Confiance/31.webp", logo: "/images/Confiance/31.webp" },
  { id: "client-nabc", type: 0, name: "NABC", titre: "NABC", image: "/images/Confiance/32.webp", logo: "/images/Confiance/32.webp" },
  { id: "client-oncf", type: 0, name: "ONCF", titre: "ONCF", image: "/images/Confiance/33.webp", logo: "/images/Confiance/33.webp" },
  { id: "client-oulmes", type: 0, name: "Oulmes", titre: "Oulmes", image: "/images/Confiance/34.webp", logo: "/images/Confiance/34.webp" },
  { id: "client-poste-maroc", type: 0, name: "Poste Maroc", titre: "Poste Maroc", image: "/images/Confiance/35.webp", logo: "/images/Confiance/35.webp" },
  { id: "client-p-and-g", type: 0, name: "P&G", titre: "P&G", image: "/images/Confiance/36.webp", logo: "/images/Confiance/36.webp" },
  { id: "client-redal", type: 0, name: "Redal", titre: "Redal", image: "/images/Confiance/37.webp", logo: "/images/Confiance/37.webp" },
  { id: "client-sews-cabind", type: 0, name: "Sews Cabind", titre: "Sews Cabind", image: "/images/Confiance/38.webp", logo: "/images/Confiance/38.webp" },
  { id: "client-shell", type: 0, name: "Shell", titre: "Shell", image: "/images/Confiance/39.webp", logo: "/images/Confiance/39.webp" },
  { id: "client-sntl", type: 0, name: "SNTL", titre: "SNTL", image: "/images/Confiance/40.webp", logo: "/images/Confiance/40.webp" },
  { id: "client-zine-developpement", type: 0, name: "Zine Developpement", titre: "Zine Developpement", image: "/images/Confiance/41.webp", logo: "/images/Confiance/41.webp" },
];

const catalogues = [
  {
    id: "catalogue-zebra",
    titre: "Catalogue Zebra",
    sous_titre: "Terminaux mobiles, scanners, imprimantes et RFID",
    description: "Selection de solutions Zebra pour la tracabilite, la mobilite et l'impression professionnelle.",
    image: "/images/Catalogue/Zebra/Terminaux_mobiles_professionnels.webp",
    file: "/",
    compagny: "ZEBRA",
    produit: "Mobilite",
  },
  {
    id: "catalogue-honeywell",
    titre: "Catalogue Honeywell",
    sous_titre: "Scanners, terminaux et imprimantes",
    description: "Equipements Honeywell adaptes aux environnements logistiques, industriels et retail.",
    image: "/images/Catalogue/Honeywell/mobile-computers.webp",
    file: "/",
    compagny: "HONEYWELL",
    produit: "Mobilite",
  },
  {
    id: "catalogue-soti",
    titre: "Catalogue SOTI",
    sous_titre: "Gestion MDM et supervision de parc",
    description: "Plateforme SOTI ONE pour administrer, securiser et superviser les flottes mobiles.",
    image: "/images/Catalogue/Soti/soti-mobicontrol.webp",
    file: "/",
    compagny: "SOTI",
    produit: "Logiciel",
  },
  {
    id: "catalogue-visual-stock",
    titre: "Visual Stock",
    sous_titre: "Solution d'inventaire et de pilotage",
    description: "Solution locale pour superviser les inventaires physiques et analyser les ecarts.",
    image: "/images/Catalogue/VisualStock/LogoVS.webp",
    file: "/",
    compagny: "TELEDYNE",
    produit: "Logiciel",
  },
];

const descriptions = {
  logiciels: {
    shortTitle: "Logiciels metier",
    description: "Solutions logicielles pour etiquetage, inventaire, mobilite, supervision et integration aux systemes existants.",
    image: "/images/ProduitPage/img/code-barre-logiciels.webp",
    secondDescription: "Nos logiciels sont selectionnes et deployes selon vos contraintes terrain : ERP, WMS, magasins, production ou services.",
    imageLogo: "/images/logo.webp",
    avantages: [
      { title: "Integration", avantage: "Connexion possible avec vos flux ERP, WMS et applications metier." },
      { title: "Pilotage", avantage: "Donnees consolidees pour suivre les operations et les ecarts." },
      { title: "Support local", avantage: "Accompagnement de proximite pour le parametrage et l'exploitation." },
    ],
  },
  default: {
    shortTitle: "Solution produit",
    description: "Une solution locale configuree pour presenter les produits sans connexion a une base de donnees.",
    image: "/images/logo.webp",
    secondDescription: "Les contenus peuvent etre enrichis dans src/api/localData.js ou remplaces par des fichiers JSON locaux.",
    imageLogo: "/images/logo.webp",
    avantages: [
      { title: "Local", avantage: "Aucune dependance a une base de donnees ou API distante." },
      { title: "Rapide", avantage: "Les contenus sont livres avec l'application." },
      { title: "Simple", avantage: "Modification possible directement dans le code ou via fichiers JSON." },
    ],
  },
};

export const localData = {
  articles: [...solutionArticles, ...homeProductArticles, ...serviceArticles],
  produits: productArticles,
  services: serviceArticles,
  solutions: solutionArticles,
  societe: societeItems,
  catalogues,
  descriptions,
};
